module.exports = __webpack_public_path__ + "static/media/280506.5b64a1ff.png";